import auth from "../../middlewares/auth";
export const settingsExamTypeRoute = [
  {
    path: '/settings/exam-type',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/ExamType/ExamTypeList'),
    name: 'settings_exam_type',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/exam-type/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/ExamType/ExamTypeForm'),
    name: 'settings_exam_type_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/exam-type/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/ExamType/ExamTypeForm'),
    name: 'settings_exam_type_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];